import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppointmentBooking from "../../../../../platform/pages/business/appointmentBooking";
import { GET_BUSINESS_BOOKING_TYPES, GET_BUSINESS_BY_URL } from "../../../../../platform/graphql/queries";
import { useQuery } from "@apollo/client";
import officePlaceHolderImage from "../../../../../platform/assets/images/business-image-placeholder.png";
import SeoMeta from "../../../../../platform/components/common/seoMeta";
const BookingTypePage = (props) => {
  const { businessUrl, bookingTypeLink } = useParams();

  const {
    loading,
    error,
    data: businessBookingTypes,
  } = useQuery(GET_BUSINESS_BOOKING_TYPES, {
    variables: {
      businessUrl
    },
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true,
  }); 
  const { data: businessData } = useQuery(GET_BUSINESS_BY_URL, {
    variables: { businessUrl },
    skip: !businessUrl,
  });

  // Add null check and fallback for bookingTypeLink
  const link = props.preview ? props.bookingTypeLink : (bookingTypeLink || props.bookingTypeLink);

  // Find the booking type from allBookingTypes
  const bookingType = businessBookingTypes?.getBusinessBookingTypes?.find((obj) => obj.link === link); 
  const business = businessData?.businessByUrl;
  const businessName =
    business?.name ||
    bookingType?.assignedStaffs?.[0]?.business?.name ||
    "Timely365";
  const seoTitle = bookingType?.title
    ? `Book ${bookingType.title} with ${businessName} | Timely365`
    : `Book an Appointment with ${businessName} | Timely365`;
  const seoDescription =
    bookingType?.desc ||
    business?.description ||
    `Schedule an appointment with ${businessName} on Timely365.`;
  const seoImage =
    bookingType?.image ||
    business?.images?.[0]?.url ||
    officePlaceHolderImage;
  const [selectedStaffId] = useState(0);
  const [isItLoading, setIsItLoading] = useState(false);
 
  useEffect(() => {
    if (isItLoading) {
      setTimeout(() => {
        setIsItLoading(false);
      }, 600);
    }
  }, [isItLoading]);

  if (loading) {
    return "Loading...";
  }

  if (error) {
    return "Error";
  }

  if (!bookingType && !props.preview) {
    return <div>Booking type not found.</div>; // Provide a fallback message when no booking type is found
  }
 
  return (
    <>
      <SeoMeta
        title={seoTitle}
        description={seoDescription}
        image={seoImage}
        type="website"
      />
      <AppointmentBooking
          selectedBookingData={bookingType}
          selectedStaffId={selectedStaffId}
          businessUrl={businessUrl}
          businessData={business}
      />
    </>
  );
};

export default BookingTypePage;
